module.exports = __webpack_public_path__ + "assets/922fc4249fdb0371139bbeee2404dcb8.png";